const TONE_BY_GO_NOGO_VOTE_TYPE = Object.freeze({
  yes: 'success',
  no: 'destructive',
  neutral: 'neutral',
});

export function getGoNoGoReasonTone(voteType) {
  if (typeof voteType !== 'string') return 'neutral';
  return TONE_BY_GO_NOGO_VOTE_TYPE[voteType.toLowerCase()] || 'neutral';
}
